
import { useState } from "react";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import { useNavigate } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import Button from "../../../common/button/Button";
import { profileFieldText, profileSectionCard } from "../../detail/common/ProfileSection";
import FieldAvatar from "./FieldAvatar";
import FieldAvatarDelete from "./FieldAvatarDelete";
import FieldIntro from "./FieldIntro";
import FieldName from "./FieldName";

export default function Form({ profile }) {
	const navigate = useNavigate();
	const [name, setName] = useState(profileFieldText(profile.name) || profile.name || "");
	const [avatar, setAvatar] = useState(profile.avatar);
	const [avatarDelete, setAvatarDelete] = useState(false);
	const [intro, setIntro] = useState(profileFieldText(profile.intro) || "");
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	const handleNameChange = (e) => {
		setName(e.target.value);
	};

	const handleAvatarChange = (file) => {
		setAvatar(file);
	};

	const handleAvatarDeleteChange = (newAvatarDelete) => {
		setAvatarDelete(newAvatarDelete);
	};

	const handleIntroChange = (e) => {
		setIntro(e.target.value);
	};

	const handleSubmit = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.profileEdit({
			token: LoginHelper.getToken(),
			name: name,
			avatar: avatar,
			avatar_delete: avatarDelete,
			intro: intro,
		})
			.then(() => {
				setIsLoading(false);
				navigate("/profile/" + profile.id + "/");
			})
			.catch((err) => {
				setIsLoading(false);
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	};

	return (
		<div className={[profileSectionCard, "flex flex-col gap-5"].join(" ")}>
			<h1 className="font-Vazir-700 text-[16px] text-darkBlue text-center pb-2 border-b border-[#E2E8F0]">
				ویرایش پروفایل
			</h1>
			<FieldName name={name} onChange={handleNameChange} />
			<FieldAvatar
				avatar={avatar}
				avatarUrl={profile.avatar_url}
				onChange={handleAvatarChange}
			/>
			<FieldAvatarDelete avatarDelete={avatarDelete} onChange={handleAvatarDeleteChange} />
			<FieldIntro intro={intro} onChange={handleIntroChange} />
			<div className="flex flex-col items-stretch gap-2 pt-2 -mx-4 sm:-mx-5 -mb-4 sm:-mb-5">
				<div className="w-full min-h-[56px] rounded-b-xl overflow-hidden shadow-[0_2px_10px_rgba(255,105,75,0.3)]">
					<Button
						onClick={() => {
							handleSubmit();
						}}
						label="ذخیره تغییرات"
						isLoading={isLoading}
						labelClassName="font-Vazir-700 text-[16px]"
					/>
				</div>
				{errorMessage ? (
					<p className="text-center font-Vazir-400 text-[14px] text-error">{errorMessage}</p>
				) : null}
			</div>
		</div>
	);
}
